import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useTraderRoomRoutesConditions } from '@pages/Traders-Room/TradersRoom.routes'

import { BarRightIcon } from '@ui/icons/BarRight.icon'
import { CandlestickIcon } from '@ui/icons/Candlestick.icon'
import { HistoryIcon } from '@ui/icons/History.icon'
import { WalletIcon } from '@ui/icons/Wallet.icon'

import { CommonPaths } from '@utils/path'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection } from '@shared/components/Navigation/menuSections/useMenuSections'

export const useTraderMenuSections = (): MenuSection[] => {
  const { t } = useTranslation()
  const { isTradersRoomVisible } = useTraderRoomRoutesConditions()
  return useMemo(() => {
    if (!isTradersRoomVisible) return []

    return [
      {
        id: 'trading-accounts',
        label: t('Tabs.Trading Accounts'),
        path: CommonPaths.TradersRoomTradingAccounts,
        products: [TickmillProductType.CFD],
        icon: CandlestickIcon,
      },
      {
        id: 'wallets',
        label: t('Tabs.Wallets'),
        path: CommonPaths.TradersRoomWallets,
        products: [TickmillProductType.CFD],
        icon: WalletIcon,
      },
      {
        id: 'balances',
        label: t('Tabs.Balances'),
        path: CommonPaths.TradersRoomBalances,
        products: [TickmillProductType.ETD],
        icon: WalletIcon,
      },
      {
        id: 'transaction-history',
        label: t('Tabs.Transaction History'),
        path: CommonPaths.TradersRoomTransactionHistory,
        icon: HistoryIcon,
      },
      {
        id: 'trading-platforms',
        label: t('Tabs.Trading Platforms'),
        path: '/dashboard/traders-room/platforms',
        products: [TickmillProductType.CFD],
        icon: BarRightIcon,
      },
    ]
  }, [t, isTradersRoomVisible])
}
